import { ActionType, createReducer } from 'typesafe-actions';
import { Winners } from 'constants/common';
import {
  resetCounterStateAction,
  setInitialCounterStateAction,
  updateBallsCounterAction,
} from './actions';
import { IBallsCounter, IBallsCounterState } from './types';

const defaultBallsCounter: IBallsCounter = {
  [Winners.PLAYER]: 0,
  [Winners.BANKER]: 0,
  [Winners.TIE]: 0,
};

export const ballsCounterState: IBallsCounterState = {
  ballsCounter: defaultBallsCounter,
};

const actions = {
  resetCounterStateAction,
  setInitialCounterStateAction,
  updateBallsCounterAction,
};

export const ballsCounterReducer = createReducer<IBallsCounterState, ActionType<typeof actions>>(
  ballsCounterState,
)
  .handleAction(resetCounterStateAction, (state) => ({
    ...state,
    ballsCounter: {
      ...state.ballsCounter,
      ...defaultBallsCounter,
    },
  }))
  .handleAction(setInitialCounterStateAction, (state, { payload: { winnersData } }) => {
    const initialBallCounter: IBallsCounter = winnersData.reduce(
      (counter, winnerBall) => ({
        ...counter,
        [winnerBall]: counter[winnerBall] + 1,
      }),
      defaultBallsCounter,
    );

    return {
      ...state,
      ballsCounter: {
        ...state.ballsCounter,
        ...initialBallCounter,
      },
    };
  })
  .handleAction(updateBallsCounterAction, (state, { payload: { winner } }) => ({
    ...state,
    ballsCounter: {
      ...state.ballsCounter,
      [winner]: state.ballsCounter[winner] + 1,
    },
  }));
